import { render, staticRenderFns } from "./TeachingLearning.vue?vue&type=template&id=0b346546&scoped=true&"
import script from "./TeachingLearning.vue?vue&type=script&lang=js&"
export * from "./TeachingLearning.vue?vue&type=script&lang=js&"
import style0 from "./TeachingLearning.vue?vue&type=style&index=0&id=0b346546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b346546",
  null
  
)

export default component.exports